export default "__VITE_ASSET__BimSrEjs__"